import { createContext } from 'react';
export const LocationContext = createContext(null);
LocationContext.displayName = 'LocationContext';
//# sourceMappingURL=LocationContext.js.map